import { IconPropsType } from '..';

export const LanguageIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 0C4.03071 0 0 4.03071 0 9C0 13.9693 4.03071 18 9 18C13.9693 18 18 13.9693 18 9C18 4.03071 13.9693 0 9 0ZM15.8721 5.99786C16.2707 6.91714 16.4957 7.93286 16.4957 9C16.4957 10.0671 16.2707 11.0829 15.8721 12.0021H12.4907C12.6579 11.07 12.7479 10.0607 12.7479 9C12.7479 7.93929 12.6579 6.93 12.4907 5.99786H15.8721ZM6.75 9C6.75 7.92 6.83357 6.90429 6.98143 5.99786H11.0121C11.16 6.89786 11.2436 7.92 11.2436 9C11.2436 10.08 11.16 11.0957 11.0121 12.0021H6.98143C6.83357 11.0957 6.75 10.08 6.75 9ZM14.9979 4.5H12.1436C11.7964 3.33 11.3143 2.36571 10.755 1.71C12.4521 2.12143 13.9564 3.105 14.9979 4.5ZM9 2.25C9.66857 2.25 10.2664 3.11786 10.6779 4.5H7.32214C7.73357 3.11786 8.33143 2.25 9 2.25ZM7.245 1.71C6.67929 2.36571 6.20357 3.33643 5.85643 4.5H3.00214C4.05 3.105 5.54786 2.115 7.245 1.71ZM2.12143 5.99786H5.50286C5.33571 6.93 5.24571 7.93929 5.24571 9C5.24571 10.0607 5.33571 11.07 5.50286 12.0021H2.12143C1.71 11.0571 1.49786 10.035 1.49786 9C1.49786 7.965 1.72286 6.91714 2.12143 5.99786ZM2.99571 13.5H5.85C6.19714 14.67 6.67929 15.6343 7.23857 16.29C5.54143 15.8786 4.03714 14.895 2.98929 13.5H2.99571ZM8.99357 15.75C8.325 15.75 7.72714 14.8821 7.31571 13.5H10.6714C10.2536 14.8821 9.66214 15.75 8.99357 15.75ZM10.7486 16.29C11.3143 15.6343 11.79 14.67 12.1371 13.5H14.9914C13.9436 14.895 12.4457 15.885 10.7486 16.29Z"
      fill="none"
    />
  </svg>
);
